import React from "react";
import "./Experience.css";
import { motion } from "framer-motion";
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { portfolioData } from "../../data/portfolioData";

const Experience = () => {
  const { experience } = portfolioData;

  return (
    <section className="experience-section" id="experience">
      <div className="experience-container">
        
        {/* Section Header */}
        <motion.div 
          className="experience-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="experience-subtitle">MY JOURNEY</span>
          <h2 className="experience-title">Professional Experience</h2>
          <p className="experience-description">
            A look into my professional background and full-stack development experience.
          </p>
        </motion.div>

        {/* Timeline Core Body */}
        <div className="experience-timeline">
          {experience.map((item, index) => (
            <motion.div 
              key={item.id}
              className="timeline-item"
              initial={{ opacity: 0, x: index % 2 === 0 ? -40 : 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              {/* Center Timeline Spine Node Connector */}
              <div className="timeline-badge">
                <FaBriefcase />
              </div>

              {/* Information Content Card Wrapper */}
              <div className="timeline-card">
                <div className="card-header-row">
                  <h3 className="timeline-role">{item.role}</h3>
                  <span className="timeline-duration">
                    <FaCalendarAlt className="meta-icon" /> {item.duration}
                  </span>
                </div>
                
                <div className="timeline-meta">
                  <span className="company-name">{item.company}</span>
                  <span className="location-tag">
                    <FaMapMarkerAlt className="meta-icon" /> {item.location}
                  </span>
                </div>

                <hr className="card-divider" />

                <p className="timeline-desc-text">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Experience;